module.exports = __webpack_public_path__ + "img/Icone_SemFundo.330909df.svg";